<mat-card class="cardWithShadow">
    <mat-card-content>
        <div class="filter-controls">
            <mat-form-field appearance="outline" class="search-field">
                <mat-label>Search</mat-label>
                <input [formControl]="searchControl" matInput placeholder="Search workflows">
                <mat-icon matSuffix>search</mat-icon>
            </mat-form-field>

            <button color="primary" mat-flat-button routerLink="/connect/workflows/new" type="button">
                <mat-icon>add</mat-icon>
                New workflow
            </button>

            <button (click)="loadWorkflows()" [disabled]="loading" aria-label="Refresh workflows" color="primary"
                    mat-icon-button>
                <mat-icon>refresh</mat-icon>
            </button>
        </div>

        @if (availableTags.length) {
            <div class="tag-filter">
                <mat-chip-listbox [multiple]="false" aria-label="Workflow tag filter">
                    <mat-chip-option (click)="applyTagFilter(null)" [selected]="!selectedTag">
                        All
                    </mat-chip-option>
                    @for (tag of availableTags; track tag) {
                        <mat-chip-option (click)="applyTagFilter(tag)" [selected]="selectedTag === tag">
                            {{ tag }}
                        </mat-chip-option>
                    }
                </mat-chip-listbox>
            </div>
        }

        @if (error) {
            <div class="error-row text-error">{{ error }}</div>
        }

        @if (loading) {
            <div class="loading-row">
                <mat-progress-spinner diameter="28" mode="indeterminate"></mat-progress-spinner>
                <span class="text-muted">Loading workflows...</span>
            </div>
        } @else {
            @if (dataSource.data.length && !hasFilteredNoResults) {
            <div class="table-responsive m-t-30">
                <table [dataSource]="dataSource.filteredData" [trackBy]="trackByWorkflow" class="w-100" mat-table>
                    <ng-container matColumnDef="name">
                        <th *matHeaderCellDef class="f-w-600 f-s-14 mat-subtitle-1 p-l-0" mat-header-cell>
                            Name
                        </th>
                        <td *matCellDef="let element" class="p-l-0 name-cell column-cell column-cell--primary" mat-cell>
                            <div class="d-flex name-cell-content">
                                <div class="workflow-icon rounded">
                                    <i-tabler class="routeIcon" name="automation"></i-tabler>
                                </div>
                                <div class="m-l-16 listing-text">
                                    <h6 class="f-s-14 mat-subtitle-1 f-w-600 listing-title">
                                        {{ element?.name }}
                                    </h6>
                                    @if (getWorkflowDescription(element)) {
                                        <span class="mat-body-1 f-s-12 listing-description">{{ getWorkflowDescription(element) }}</span>
                                    }
                                    @if (element?.tags?.length) {
                                        <div class="workflow-tags">
                                            @for (tag of element.tags; track tag) {
                                                <span class="tag-pill">{{ tag }}</span>
                                            }
                                        </div>
                                    }
                                    @if (getWorkflowMetaLine(element)) {
                                        <span class="mat-body-1 f-s-12 listing-meta">{{ getWorkflowMetaLine(element) }}</span>
                                    }
                                </div>
                            </div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="edit">
                        <th *matHeaderCellDef class="f-w-600 f-s-14 mat-subtitle-1" mat-header-cell>
                            Edit
                        </th>
                        <td *matCellDef="let element" class="mat-body-1 column-cell column-cell--action" mat-cell>
                            @if (workflowRoute(element); as route) {
                                <a [routerLink]="route" aria-label="Edit workflow" class="edit-link">
                                    <i-tabler class="routeIcon" name="edit"></i-tabler>
                                </a>
                            } @else {
                                <span aria-label="Guided editing unavailable" class="edit-link" role="img">
                                    <i-tabler class="routeIcon" name="lock"></i-tabler>
                                </span>
                            }
                        </td>
                    </ng-container>

                    <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
                    <tr *matRowDef="let row; columns: displayedColumns" [routerLink]="workflowRoute(row)"
                        [class.workflow-row--disabled]="isGuidedUnavailable(row)"
                        mat-row></tr>
                </table>
            </div>
            }

            @if (!dataSource.data.length) {
                <p class="text-muted empty-state">No workflows yet. Create one to get started.</p>
            } @else if (hasFilteredNoResults) {
                <div aria-live="polite" class="empty-state">
                    <p class="text-muted">No workflows match your filters.</p>
                    <button (click)="clearFilters()" mat-button type="button">Clear filters</button>
                </div>
            }
        }
    </mat-card-content>
</mat-card>
